import React from "react";
import {
  Heading,
  Text,
  Box,
  Divider,
  UnorderedList,
  ListItem,
  Link,
} from "@chakra-ui/react";

export const TermsAndConditions = () => (
  <Box>
    <Box mb="8">
      <Heading as="h1" mb="28">
        Terms and Conditions of <strong>Basilium</strong>
      </Heading>
      <Text mb='2'>These Terms govern</Text>
      <UnorderedList>
        <ListItem>the use of Basilium, and,</ListItem>
        <ListItem>
          any other related Agreement or legal relationship with the Owner
        </ListItem>
      </UnorderedList>
      <Text mb='2'>
        in a legally binding way. Capitalized words are defined in the relevant
        dedicated section of this document.
      </Text>
      <br />
      <Text mb='2'>The User must read this document carefully.</Text>
    </Box>
    <Divider mb="4" />
    <Text mb='2'>
      Although the entire contractual relationship relating to these Products is
      entered into solely by the Owner and Users, Users acknowledge and agree
      that, where Basilium has been provided to them via the Apple App Store,
      Apple may enforce these Terms as a third-party beneficiary.
    </Text>
    <Text mb='2'>
      Nothing in these Terms creates any relationship of employment, agency, or
      partnership between the involved parties.
    </Text>
    <Text mb='2'>Basilium is provided by:</Text>
    <Text mb='2'>
      Daniel Dauk&scaron;evič <br />
      Ukmergės str. 306, Vilnius, Lithuania
    </Text>
    <Text mb='2'>
      <strong>Owner contact email:</strong> legal@basilium.app
    </Text>
    <Text mb='2'>"Basilium" refers to</Text>
    <UnorderedList>
      <ListItem>
        this website, including its subdomains and any other website through
        which the Owner makes its Service available;
      </ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>
        applications for mobile, tablet and other smart device systems;
      </ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>the Service;</ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>
        any applications, sample and content files, source code, scripts,
        instruction sets or software included as part of the Service, as well as
        any related documentation;
      </ListItem>
    </UnorderedList>
    <Heading as="h2" size="md" mb="4" mt="8">
      What the User should know at a glance
    </Heading>
    <UnorderedList>
      <ListItem>
        <strong>Usage of Basilium and the Service is age restricted</strong>: to
        access and use Basilium and its Service the User must be an adult under
        applicable law.
      </ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>The Service/Basilium is only intended for Consumers.</ListItem>
    </UnorderedList>
    <Divider mt="4" />
    <Box mt="8" />
    <Heading as="h2" size="md" mb="4" mt="8">
      Disclaimers
    </Heading>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Professional Disclaimer
    </Heading>
    <Text mb='2'>
      Basilium can not and does not contain medical, health, or fitness advice.
      The information is provided for general informational and educational
      purposes only and is not a substitute for professional medical, health, or
      fitness advice. Accordingly, before taking any actions based upon such
      information, you should consult with the appropriate professionals.
      Basilium does not provide any kind of medical, health, or fitness advice.
    </Text>
    <Text mb='2'>
      Content published on Basilium is intended to be used and must be used for
      informational purposes only. It is very important to do your own analysis
      before making any decision based on your own personal circumstances. You
      should take independent medical, health, or fitness advice from a
      professional or independently research and verify any information that you
      find on Basilium and wish to rely upon.
    </Text>
    <Text mb='2'>
      THE USE OR RELIANCE OF ANY INFORMATION CONTAINED ON BASILIUM IS SOLELY AT
      YOUR OWN RISK.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Errors And Omissions Disclaimer
    </Heading>
    <Text mb='2'>
      While every attempt has been made to ensure that the information contained
      in Basilium has been obtained from reliable sources, the Owner is not
      responsible for any errors or omissions or for the results obtained from
      the use of this information. All information on Basilium is provided
      &ldquo;as is&rdquo;, with no guarantee of completeness, accuracy,
      timeliness, or of the results obtained from the use of this information,
      and without warranty of any kind, express or implied, including, but not
      limited to warranties of performance, merchantability, and fitness for a
      particular purpose.
    </Text>
    <Text mb='2'>
      In no event will the Owner, its related partnerships or corporations, or
      the partners, agents or employees thereof be liable to you or anyone else
      for any decision made or action taken in reliance on the information in
      Basilium or for any consequential, special or similar damages, even if
      advised of the possibility of such damages.
    </Text>
    <Heading as="h2" size="md" mb="4" mt="8">
      TERMS OF USE
    </Heading>
    <Text mb='2'>
      Unless otherwise specified, the terms of use detailed in this section
      apply generally when using Basilium.
    </Text>
    <Text mb='2'>
      Single or additional conditions of use or access may apply in specific
      scenarios and in such cases are additionally indicated within this
      document.
    </Text>
    <Text mb='2'>
      By using Basilium, Users confirm to meet the following requirements:
    </Text>
    <UnorderedList>
      <ListItem>Users must qualify as Consumers;</ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>Users must be recognized as adult by applicable law;</ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>
        Users aren&rsquo;t located in a country that is subject to a U.S.
        Government embargo, or that has been designated by the U.S. Government
        as a &ldquo;terrorist-supporting&rdquo; country;
      </ListItem>
      <ListItem>
        Users aren&rsquo;t listed on any U.S. Government list of prohibited or
        restricted parties;
      </ListItem>
    </UnorderedList>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Account registration
    </Heading>
    <Text mb='2'>
      To use the Service Users must register or create a User account, providing
      all required data or information in a complete and truthful manner.
      <br /> Failure to do so will cause unavailability of the Service.
    </Text>
    <Text mb='2'>
      Users are responsible for keeping their login credentials confidential and
      safe. For this reason, Users are also required to choose passwords that
      meet the highest standards of strength permitted by Basilium.
    </Text>
    <Text mb='2'>
      By registering, Users agree to be fully responsible for all activities
      that occur under their username and password.
      <br /> Users are required to immediately and unambiguously inform the
      Owner via the contact details indicated in this document, if they think
      their personal information, including but not limited to User accounts,
      access credentials or personal data, have been violated, unduly disclosed
      or stolen.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Conditions for account registration
    </Heading>
    <Text mb='2'>
      Registration of User accounts on Basilium is subject to the conditions
      outlined below. By registering, Users agree to meet such conditions.
    </Text>
    <UnorderedList>
      <ListItem>
        Accounts registered by bots or any other automated methods are not
        permitted.
      </ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>
        Unless otherwise specified, each User must register only one account.
      </ListItem>
    </UnorderedList>
    <UnorderedList>
      <ListItem>
        Unless explicitly permitted, a User account may not be shared with other
        persons.
      </ListItem>
    </UnorderedList>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Account termination
    </Heading>
    <Text mb='2'>
      Users can terminate their account and stop using the Service at any time
      by doing the following:
    </Text>
    <UnorderedList>
      <ListItem>
        By using the tools provided for account termination on Basilium.
      </ListItem>
    </UnorderedList>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Account suspension and deletion
    </Heading>
    <Text mb='2'>
      The Owner reserves the right, at its sole discretion, to suspend or delete
      at any time and without notice, User accounts which it deems
      inappropriate, offensive or in violation of these Terms.
    </Text>
    <Text mb='2'>
      The suspension or deletion of User accounts shall not entitle Users to any
      claims for compensation, damages or reimbursement.
    </Text>
    <Text mb='2'>
      The suspension or deletion of accounts due to causes attributable to the
      User does not exempt the User from paying any applicable fees or prices.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Content on Basilium
    </Heading>
    <Text mb='2'>
      Unless where otherwise specified or clearly recognizable, all content
      available on Basilium is owned or provided by the Owner or its licensors.
    </Text>
    <Text mb='2'>
      The Owner undertakes its utmost effort to ensure that the content provided
      on Basilium infringes no applicable legal provisions or third-party
      rights. However, it may not always be possible to achieve such a result.
      <br /> In such cases, without prejudice to any legal prerogatives of Users
      to enforce their rights, Users are kindly asked to preferably report
      related complaints using the contact details provided in this document.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Rights regarding content on Basilium - All rights reserved
    </Heading>
    <Text mb='2'>
      The Owner holds and reserves all intellectual property rights for any such
      content.
    </Text>
    <Text mb='2'>
      Users may not therefore use such content in any way that is not necessary
      or implicit in the proper use of the Service.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Access to external resources
    </Heading>
    <Text mb='2'>
      Through Basilium Users may have access to external resources provided by
      third parties. Users acknowledge and accept that the Owner has no control
      over such resources and is therefore not responsible for their content and
      availability.
    </Text>
    <Text mb='2'>
      Conditions applicable to any resources provided by third parties,
      including those applicable to any possible grant of rights in content,
      result from each such third parties&rsquo; terms and conditions or, in the
      absence of those, applicable statutory law.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Acceptable use
    </Heading>
    <Text mb='2'>
      Basilium and the Service may only be used within the scope of what they
      are provided for, under these Terms and applicable law.
    </Text>
    <Text mb='2'>
      Users are solely responsible for making sure that their use of Basilium
      and/or the Service violates no applicable law, regulations or third-party
      rights.
    </Text>
    <Text mb='2'>
      Therefore, the Owner reserves the right to take any appropriate measure to
      protect its legitimate interests including by denying Users access to
      Basilium or the Service, terminating contracts, reporting any misconduct
      performed through Basilium or the Service to the competent authorities
      &ndash; such as judicial or administrative authorities - whenever Users
      engage or are suspected to engage in any of the following activities:
    </Text>
    <UnorderedList>
      <ListItem>violate laws, regulations and/or these Terms;</ListItem>
      <ListItem>infringe any third-party rights;</ListItem>
      <ListItem>
        considerably impair the Owner&rsquo;s legitimate interests;
      </ListItem>
      <ListItem>offend the Owner or any third party.</ListItem>
    </UnorderedList>
    <Heading as="h2" size="md" mb="4" mt="8">
      TERMS AND CONDITIONS OF SALE
    </Heading>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Paid Products
    </Heading>
    <Text mb='2'>
      Some of the Products provided on Basilium, as part of the Service, are
      provided on the basis of payment.
    </Text>
    <Text mb='2'>
      The fees, duration and conditions applicable to the purchase of such
      Products are described below and in the dedicated sections of Basilium.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Product description
    </Heading>
    <Text mb='2'>
      Prices, descriptions or availability of Products are outlined in the
      respective sections of Basilium and are subject to change without notice.
    </Text>
    <Text mb='2'>
      While Products on Basilium are presented with the greatest accuracy
      technically possible, representation on Basilium through any means
      (including, as the case may be, graphic material, images, colors, sounds)
      is for reference only and implies no warranty as to the characteristics of
      the purchased Product.
    </Text>
    <Text mb='2'>
      The characteristics of the chosen Product will be outlined during the
      purchasing process.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Purchasing process
    </Heading>
    <Text mb='2'>
      Any steps taken from choosing a Product to order submission form part of
      the purchasing process.
    </Text>
    <Text mb='2'>The purchasing process includes these steps:</Text>
    <UnorderedList>
      <ListItem>
        Users must choose the desired Product and verify their purchase
        selection.
      </ListItem>
      <ListItem>
        After having reviewed the information displayed in the purchase
        selection, Users may place the order by submitting it.
      </ListItem>
    </UnorderedList>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Order submission
    </Heading>
    <Text mb='2'>When the User submits an order, the following applies:</Text>
    <UnorderedList>
      <ListItem>
        The submission of an order determines contract conclusion and therefore
        creates for the User the obligation to pay the price, taxes and possible
        further fees and expenses, as specified on the order page.
      </ListItem>
      <ListItem>
        In case the purchased Product requires active input from the User, such
        as the provision of personal information or data, specifications or
        special wishes, the order submission creates an obligation for the User
        to cooperate accordingly.
      </ListItem>
      <ListItem>
        Upon submission of the order, Users will receive a receipt confirming
        that the order has been received.
      </ListItem>
    </UnorderedList>
    <Text mb='2'>
      All notifications related to the described purchasing process shall be
      sent to the email address provided by the User for such purposes.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Prices
    </Heading>
    <Text mb='2'>
      Users are informed during the purchasing process and before order
      submission, about any fees, taxes and costs (including, if any, delivery
      costs) that they will be charged.
    </Text>
    <Text mb='2'>Prices on Basilium are displayed:</Text>
    <UnorderedList>
      <ListItem>
        either exclusive or inclusive of any applicable fees, taxes and costs,
        depending on the section the User is browsing.
      </ListItem>
    </UnorderedList>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Methods of payment
    </Heading>
    <Text mb='2'>
      Information related to accepted payment methods are made available during
      the purchasing process.
    </Text>
    <Text mb='2'>
      Some payment methods may only be available subject to additional
      conditions or fees. In such cases related information can be found in the
      dedicated section of Basilium.
    </Text>
    <Text mb='2'>
      All payments are independently processed through third-party services.
      Therefore, Basilium does not collect any payment information &ndash; such
      as credit card details &ndash; but only receives a notification once the
      payment has been successfully completed.
    </Text>
    <Text mb='2'>
      If payment through the available methods fail or is refused by the payment
      service provider, the Owner shall be under no obligation to fulfil the
      purchase order. Any possible costs or fees resulting from the failed or
      refused payment shall be borne by the User.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Purchase via app store
    </Heading>
    <Text mb='2'>
      Basilium or specific Products available for sale on Basilium must be
      purchased via a third-party app store. To access such purchases, Users
      must follow the instructions provided on the relevant online store (such
      as "Apple App Store" or "Google Play"), which may vary depending on the
      particular device in use.
    </Text>
    <Text mb='2'>
      Unless otherwise specified, purchases done via third-party online stores
      are also subject to such third-parties&rsquo; terms and conditions, which,
      in case of any inconsistency or conflict, shall always prevail upon these
      Terms.
    </Text>
    <Text mb='2'>
      Users purchasing through such third-party online stores must therefore
      read such terms and conditions of sale carefully and accept them.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Retention of usage rights
    </Heading>
    <Text mb='2'>
      Users do not acquire any rights to use the purchased Product until the
      total purchase price is received by the Owner.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Delivery
    </Heading>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Performance of services
    </Heading>
    <Text mb='2'>
      The purchased service shall be performed or made available within the
      timeframe specified on Basilium or as communicated before the order
      submission.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Right of withdrawal
    </Heading>
    <Text mb='2'>
      By subscribing to Basilium you acknowledge that you lost your right to
      withdrawal, but this does not affect your right to cancel your membership
      at any time. The right of withdrawal is a right that allows European
      consumers to withdraw from their contract within 14 days of its effective
      date. Since we at Basilium already provide our customers with 30 days of
      free trial, we rely on an exception for digital content providers, and our
      service does not include a right of withdrawal. Basilium does not offer a
      right of withdrawal in any European country, however you can cancel at any
      time during the free trial of 30 days or after. After 30 days from your
      purchase, you may cancel your subscription as described above but you will
      not receive a refund. Specifically, at the end of the trial we will
      automatically apply the yearly/monthly price, at the then-current
      yearly/monthly price, and start charge your payment details on a
      yearly/monthly recurring basis, unless you cancel or change your
      subscription before the trial period ends. The law requires us to inform
      you that you do not have a right of withdrawal. To this end, when our
      customers sign up in any European country they acknowledge that they lose
      their right of withdrawal. Acknowledging that you lose your right of
      withdrawal will not affect any of your other rights as a consumer and will
      not affect your ability to cancel your subscription at any time.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Refunds
    </Heading>
    <Text mb='2'>
      Given that we at Basilium already provide our customers with 30 days of
      free trial, Refunds will not, however, be provided once that the free
      trial period of 30 days expires.
    </Text>
    <Heading as="h2" size="md" mb="4" mt="8">
      Liability and indemnification
    </Heading>
    <Heading as="h3" size="sm" mb="4" mt="8">
      EU Users
    </Heading>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Indemnification
    </Heading>
    <Text mb='2'>
      The User agrees to indemnify and hold the Owner and its subsidiaries,
      affiliates, officers, directors, agents, co-branders, partners and
      employees harmless from and against any claim or demand ⁠&mdash; including
      but not limited to lawyer's fees and costs ⁠&mdash; made by any third
      party due to or in relation with any culpable use of or connection to the
      Service, violation of these Terms, infringement of any third-party rights
      or statutory provision by the User or its affiliates, officers, directors,
      agents, co-branders, partners and employees to the extent allowed by
      applicable law.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Limitation of liability
    </Heading>
    <Text mb='2'>
      Unless otherwise explicitly stated and without prejudice to applicable
      statutory product liability provisions, Users shall have no right to claim
      damages against the Owner (or any natural or legal person acting on its
      behalf).
    </Text>
    <Text mb='2'>
      This does not apply to damages to life, health or physical integrity,
      damages resulting from the breach of an essential contractual obligation
      such as any obligation strictly necessary to achieve the purpose of the
      contract, and/or damages resulting from intent or gross negligence, as
      long as Basilium has been appropriately and correctly used by the User.
    </Text>
    <Text mb='2'>
      Unless damages have been caused by way of intent or gross negligence, or
      they affect life, health or physical integrity, the Owner shall only be
      liable to the extent of typical and foreseeable damages at the moment the
      contract was entered into.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Australian Users
    </Heading>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Limitation of liability
    </Heading>
    <Text mb='2'>
      Nothing in these Terms excludes, restricts or modifies any guarantee,
      condition, warranty, right or remedy which the User may have under the
      Competition and Consumer Act 2010 (Cth) or any similar State and Territory
      legislation and which cannot be excluded, restricted or modified
      (non-excludable right). To the fullest extent permitted by law, our
      liability to the User, including liability for a breach of a
      non-excludable right and liability which is not otherwise excluded under
      these Terms of Use, is limited, at the Owner&rsquo;s sole discretion, to
      the re-performance of the services or the payment of the cost of having
      the services supplied again.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      US Users
    </Heading>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Disclaimer of Warranties
    </Heading>
    <Text mb='2'>
      <strong>
        Basilium is provided strictly on an &ldquo;as is&rdquo; and &ldquo;as
        available&rdquo; basis. Use of the Service is at Users&rsquo; own risk.
        To the maximum extent permitted by applicable law, the Owner expressly
        disclaims all conditions, representations, and warranties &mdash;
        whether express, implied, statutory or otherwise, including, but not
        limited to, any implied warranty of merchantability, fitness for a
        particular purpose, or non-infringement of third-party rights. No advice
        or information, whether oral or written, obtained by user from owner or
        through the Service will create any warranty not expressly stated
        herein.
      </strong>
    </Text>
    <Text mb='2'>
      <strong>
        Without limiting the foregoing, the Owner, its subsidiaries, affiliates,
        licensors, officers, directors, agents, co-branders, partners, suppliers
        and employees do not warrant that the content is accurate, reliable or
        correct; that the Service will meet Users&rsquo; requirements; that the
        Service will be available at any particular time or location,
        uninterrupted or secure; that any defects or errors will be corrected;
        or that the Service is free of viruses or other harmful components. Any
        content downloaded or otherwise obtained through the use of the Service
        is downloaded at users own risk and users shall be solely responsible
        for any damage to Users&rsquo; computer system or mobile device or loss
        of data that results from such download or Users&rsquo; use of the
        Service.
      </strong>
    </Text>
    <Text mb='2'>
      <strong>
        The Owner does not warrant, endorse, guarantee, or assume responsibility
        for any product or service advertised or offered by a third party
        through the Service or any hyperlinked website or service, and the Owner
        shall not be a party to or in any way monitor any transaction between
        Users and third-party providers of products or services.
      </strong>
    </Text>
    <Text mb='2'>
      <strong>
        The Service may become inaccessible or it may not function properly with
        Users&rsquo; web browser, mobile device, and/or operating system. The
        owner cannot be held liable for any perceived or actual damages arising
        from Service content, operation, or use of this Service.
      </strong>
    </Text>
    <Text mb='2'>
      <strong>
        Federal law, some states, and other jurisdictions, do not allow the
        exclusion and limitations of certain implied warranties. The above
        exclusions may not apply to Users. This Agreement gives Users specific
        legal rights, and Users may also have other rights which vary from state
        to state. The disclaimers and exclusions under this agreement shall not
        apply to the extent prohibited by applicable law.
      </strong>
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Limitations of liability
    </Heading>
    <Text mb='2'>
      <strong>
        To the maximum extent permitted by applicable law, in no event shall the
        Owner, and its subsidiaries, affiliates, officers, directors, agents,
        co-branders, partners, suppliers and employees be liable for
      </strong>
    </Text>
    <UnorderedList>
      <ListItem>
        <strong>
          any indirect, punitive, incidental, special, consequential or
          exemplary damages, including without limitation damages for loss of
          profits, goodwill, use, data or other intangible losses, arising out
          of or relating to the use of, or inability to use, the Service; and
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          any damage, loss or injury resulting from hacking, tampering or other
          unauthorized access or use of the Service or User account or the
          information contained therein;
        </strong>
      </ListItem>
      <ListItem>
        <strong>any errors, mistakes, or inaccuracies of content;</strong>
      </ListItem>
      <ListItem>
        <strong>
          personal injury or property damage, of any nature whatsoever,
          resulting from User access to or use of the Service;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          any unauthorized access to or use of the Owner&rsquo;s secure servers
          and/or any and all personal information stored therein;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          any interruption or cessation of transmission to or from the Service;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          any bugs, viruses, trojan horses, or the like that may be transmitted
          to or through the Service;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          any errors or omissions in any content or for any loss or damage
          incurred as a result of the use of any content posted, emailed,
          transmitted, or otherwise made available through the Service; and/or
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          the defamatory, offensive, or illegal conduct of any User or third
          party. In no event shall the Owner, and its subsidiaries, affiliates,
          officers, directors, agents, co-branders, partners, suppliers and
          employees be liable for any claims, proceedings, liabilities,
          obligations, damages, losses or costs in an amount exceeding the
          amount paid by User to the Owner hereunder in the preceding 12 months,
          or the period of duration of this agreement between the Owner and
          User, whichever is shorter.
        </strong>
      </ListItem>
    </UnorderedList>
    <Text mb='2'>
      <strong>
        This limitation of liability section shall apply to the fullest extent
        permitted by law in the applicable jurisdiction whether the alleged
        liability is based on contract, tort, negligence, strict liability, or
        any other basis, even if company has been advised of the possibility of
        such damage.
      </strong>
    </Text>
    <Text mb='2'>
      <strong>
        Some jurisdictions do not allow the exclusion or limitation of
        incidental or consequential damages, therefore the above limitations or
        exclusions may not apply to User. The terms give User specific legal
        rights, and User may also have other rights which vary from jurisdiction
        to jurisdiction. The disclaimers, exclusions, and limitations of
        liability under the terms shall not apply to the extent prohibited by
        applicable law.
      </strong>
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Indemnification
    </Heading>
    <Text mb='2'>
      <strong>
        The User agrees to defend, indemnify and hold the Owner and its
        subsidiaries, affiliates, officers, directors, agents, co-branders,
        partners, suppliers and employees harmless from and against any and all
        claims or demands, damages, obligations, losses, liabilities, costs or
        debt, and expenses, including, but not limited to, legal fees and
        expenses, arising from
      </strong>
    </Text>
    <UnorderedList>
      <ListItem>
        <strong>
          User&rsquo;s use of and access to the Service, including any data or
          content transmitted or received by User;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          User&rsquo;s violation of these terms, including, but not limited to,
          User&rsquo;s breach of any of the representations and warranties set
          forth in these terms;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          User&rsquo;s violation of any third-party rights, including, but not
          limited to, any right of privacy or intellectual property rights;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          User&rsquo;s violation of any statutory law, rule, or regulation;
        </strong>
      </ListItem>
      <ListItem>
        <strong>
          any content that is submitted from User&rsquo;s account, including
          third party access with User&rsquo;s unique username, password or
          other security measure, if applicable, including, but not limited to,
          misleading, false, or inaccurate information;
        </strong>
      </ListItem>
      <ListItem>
        <strong>User&rsquo;s wilful misconduct; or</strong>
      </ListItem>
      <ListItem>
        <strong>
          statutory provision by User or its affiliates, officers, directors,
          agents, co-branders, partners, suppliers and employees to the extent
          allowed by applicable law.
        </strong>
      </ListItem>
    </UnorderedList>
    <Heading as="h2" size="md" mb="4" mt="8">
      Common provisions
    </Heading>
    <Heading as="h3" size="sm" mb="4" mt="8">
      No Waiver
    </Heading>
    <Text mb='2'>
      The Owner&rsquo;s failure to assert any right or provision under these
      Terms shall not constitute a waiver of any such right or provision. No
      waiver shall be considered a further or continuing waiver of such term or
      any other term.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Service interruption
    </Heading>
    <Text mb='2'>
      To ensure the best possible service level, the Owner reserves the right to
      interrupt the Service for maintenance, system updates or any other
      changes, informing the Users appropriately.
    </Text>
    <Text mb='2'>
      Within the limits of law, the Owner may also decide to suspend or
      terminate the Service altogether. If the Service is terminated, the Owner
      will cooperate with Users to enable them to withdraw Personal Data or
      information in accordance with applicable law.
    </Text>
    <Text mb='2'>
      Additionally, the Service might not be available due to reasons outside
      the Owner&rsquo;s reasonable control, such as &ldquo;force majeure&rdquo;
      (eg. labor actions, infrastructural breakdowns or blackouts etc).
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Service reselling
    </Heading>
    <Text mb='2'>
      Users may not reproduce, duplicate, copy, sell, resell or exploit any
      portion of Basilium and of its Service without the Owner&rsquo;s express
      prior written permission, granted either directly or through a legitimate
      reselling programme.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Privacy policy
    </Heading>
    <Text mb='2'>
      To learn more about the use of their Personal Data, Users may refer to the
      privacy policy of Basilium.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Intellectual property rights
    </Heading>
    <Text mb='2'>
      Without prejudice to any more specific provision of these Terms, any
      intellectual property rights, such as copyrights, trademark rights, patent
      rights and design rights related to Basilium are the exclusive property of
      the Owner or its licensors and are subject to the protection granted by
      applicable laws or international treaties relating to intellectual
      property.
    </Text>
    <Text mb='2'>
      All trademarks &mdash; nominal or figurative &mdash; and all other marks,
      trade names, service marks, word marks, illustrations, images, or logos
      appearing in connection with Basilium are, and remain, the exclusive
      property of the Owner or its licensors and are subject to the protection
      granted by applicable laws or international treaties related to
      intellectual property.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Changes to these Terms
    </Heading>
    <Text mb='2'>
      The Owner reserves the right to amend or otherwise modify these Terms at
      any time. In such cases, the Owner will appropriately inform the User of
      these changes.
    </Text>
    <Text mb='2'>
      Such changes will only affect the relationship with the User for the
      future.
    </Text>
    <Text mb='2'>
      The continued use of the Service will signify the User&rsquo;s acceptance
      of the revised Terms. If Users do not wish to be bound by the changes,
      they must stop using the Service. Failure to accept the revised Terms, may
      entitle either party to terminate the Agreement.
    </Text>
    <Text mb='2'>
      The applicable previous version will govern the relationship prior to the
      User's acceptance. The User can obtain any previous version from the
      Owner.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Assignment of contract
    </Heading>
    <Text mb='2'>
      The Owner reserves the right to transfer, assign, dispose of by novation,
      or subcontract any or all rights or obligations under these Terms, taking
      the User&rsquo;s legitimate interests into account. Provisions regarding
      changes of these Terms will apply accordingly.
    </Text>
    <Text mb='2'>
      Users may not assign or transfer their rights or obligations under these
      Terms in any way, without the written permission of the Owner.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Contacts
    </Heading>
    <Text mb='2'>
      All communications relating to the use of Basilium must be sent using the
      contact information stated in this document.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Severability
    </Heading>
    <Text mb='2'>
      Should any provision of these Terms be deemed or become invalid or
      unenforceable under applicable law, the invalidity or unenforceability of
      such provision shall not affect the validity of the remaining provisions,
      which shall remain in full force and effect.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      US Users
    </Heading>
    <Text mb='2'>
      Any such invalid or unenforceable provision will be interpreted, construed
      and reformed to the extent reasonably required to render it valid,
      enforceable and consistent with its original intent. These Terms
      constitute the entire Agreement between Users and the Owner with respect
      to the subject matter hereof, and supersede all other communications,
      including but not limited to all prior agreements, between the parties
      with respect to such subject matter. These Terms will be enforced to the
      fullest extent permitted by law.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      EU Users
    </Heading>
    <Text mb='2'>
      Should any provision of these Terms be or be deemed void, invalid or
      unenforceable, the parties shall do their best to find, in an amicable
      way, an agreement on valid and enforceable provisions thereby substituting
      the void, invalid or unenforceable parts.
      <br /> In case of failure to do so, the void, invalid or unenforceable
      provisions shall be replaced by the applicable statutory provisions, if so
      permitted or stated under the applicable law.
    </Text>
    <Text mb='2'>
      Without prejudice to the above, the nullity, invalidity or the
      impossibility to enforce a particular provision of these Terms shall not
      nullify the entire Agreement, unless the severed provisions are essential
      to the Agreement, or of such importance that the parties would not have
      entered into the contract if they had known that the provision would not
      be valid, or in cases where the remaining provisions would translate into
      an unacceptable hardship on any of the parties.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Governing law
    </Heading>
    <Text mb='2'>
      These Terms are governed by the law of the place where the Owner is based,
      as disclosed in the relevant section of this document, without regard to
      conflict of laws principles.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Exception for European Consumers
    </Heading>
    <Text mb='2'>
      However, regardless of the above, if the User qualifies as a European
      Consumer and has their habitual residence in a country where the law
      provides for a higher consumer protection standard, such higher standards
      shall prevail.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Venue of jurisdiction
    </Heading>
    <Text mb='2'>
      The exclusive competence to decide on any controversy resulting from or
      connected to these Terms lies with the courts of the place where the Owner
      is based, as displayed in the relevant section of this document.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Exception for European Consumers
    </Heading>
    <Text mb='2'>
      The above does not apply to any Users that qualify as European Consumers,
      nor to Consumers based in Switzerland, Norway or Iceland.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      UK Consumers
    </Heading>
    <Text mb='2'>
      Consumers based in England and Wales may bring legal proceedings in
      connection with these Terms in the English and Welsh courts. Consumers
      based in Scotland may bring legal proceedings in connection with these
      Terms in either the Scottish or the English courts. Consumers based in
      Northern Ireland may bring legal proceedings in connection with these
      Terms in either the Northern Irish or the English courts.
    </Text>
    <Heading as="h4" size="xs" mb="4" mt="8">
      US Users
    </Heading>
    <Text mb='2'>
      <strong>
        Each party specifically waives any right to trial by jury in any court
        in connection with any action or litigation.
      </strong>
      <br />{" "}
      <strong>
        Any claims under these terms shall proceed individually and no party
        shall join in a class action or other proceeding with or on behalf of
        others.
      </strong>
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      US Users
    </Heading>
    <Heading as="h4" size="xs" mb="4" mt="8">
      Surviving provisions
    </Heading>
    <Text mb='2'>
      This Agreement shall continue in effect until it is terminated by either
      Basilium or the User. Upon termination, the provisions contained in these
      Terms that by their context are intended to survive termination or
      expiration will survive, including but not limited to the following:
    </Text>
    <UnorderedList>
      <ListItem>
        the User&rsquo;s grant of licenses under these Terms shall survive
        indefinitely;
      </ListItem>
      <ListItem>
        the User&rsquo;s indemnification obligations shall survive for a period
        of five years from the date of termination;
      </ListItem>
      <ListItem>
        the disclaimer of warranties and representations, and the stipulations
        under the section containing indemnity and limitation of liability
        provisions, shall survive indefinitely.
      </ListItem>
    </UnorderedList>
    <Heading as="h2" size="md" mb="4" mt="8">
      Dispute resolution
    </Heading>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Amicable dispute resolution
    </Heading>
    <Text mb='2'>
      Users may bring any disputes to the Owner who will try to resolve them
      amicably.
    </Text>
    <Text mb='2'>
      While Users' right to take legal action shall always remain unaffected, in
      the event of any controversy regarding the use of Basilium or the Service,
      Users are kindly asked to contact the Owner at the contact details
      provided in this document.
    </Text>
    <Text mb='2'>
      The User may submit the complaint including a brief description and if
      applicable, the details of the related order, purchase, or account, to the
      Owner&rsquo;s email address specified in this document.
    </Text>
    <Text mb='2'>
      The Owner will process the complaint without undue delay and within 21
      days of receiving it.
    </Text>
    <Heading as="h3" size="sm" mb="4" mt="8">
      Online dispute resolution for Consumers
    </Heading>
    <Text mb='2'>
      The European Commission has established an online platform for alternative
      dispute resolutions that facilitates an out-of-court method for solving
      any dispute related to and stemming from online sale and service
      contracts.
    </Text>
    <Text mb='2'>
      As a result, any European Consumer can use such platform for resolving any
      dispute stemming from contracts which have been entered into online. The
      platform is{" "}
      <Link
        color="blue.500"
        _hover={{
          color: "blue.300",
        }}
        href="http://ec.europa.eu/consumers/odr/"
      >
        available at the following link
      </Link>
      .
    </Text>
    <Divider mt="4" />
    <Box my="8">
      <Box my="8"  mt="8" borderWidth='thin'>
        <Heading as="h3" size="sm" borderBottomWidth='thin' p='4'>
          Definitions and legal references
        </Heading>
        <Box my="8" px='4'>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Basilium (or this Application)
          </Heading>
          <Text mb='2'>The property that enables the provision of the Service.</Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Agreement
          </Heading>
          <Text mb='2'>
            Any legally binding or contractual relationship between the Owner
            and the User, governed by these Terms.
          </Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            European (or Europe)
          </Heading>
          <Text mb='2'>
            Applies where a User is physically present or has their registered
            offices within the EU, regardless of nationality.
          </Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Owner (or We)
          </Heading>
          <Text mb='2'>
            Indicates the natural person(s) or legal entity that provides
            Basilium and/or the Service to Users.
          </Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Product
          </Heading>
          <Text mb='2'>
            A good or service available for purchase through Basilium, such as
            e.g. physical goods, digital files, software, booking services etc.
          </Text>
          <Text mb='2'>The sale of Products may be part of the Service.</Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Service
          </Heading>
          <Text mb='2'>
            The service provided by Basilium as described in these Terms and on
            Basilium.
          </Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Terms
          </Heading>
          <Text mb='2'>
            All provisions applicable to the use of Basilium and/or the Service
            as described in this document, including any other related documents
            or agreements, and as updated from time to time.
          </Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            User (or You)
          </Heading>
          <Text mb='2'>
            Indicates any natural person or legal entity using Basilium.
          </Text>
          <Heading as="h4" size="xs" mb="4" mt="8">
            Consumer
          </Heading>
          <Text mb='2'>
            Any User qualifying as a natural person who accesses goods or
            services for personal use, or more generally, acts for purposes
            outside their trade, business, craft or profession.
          </Text>
        </Box>
      </Box>
    </Box>
    <Box my="8">
      <Text mb='2'>Latest update: November 12, 2021</Text>
    </Box>
  </Box>
);
